import { ExitIcon } from '@radix-ui/react-icons';

import { button } from './accountOptions.css';
import { buttonText } from './sharedNavStyles.css';

export interface AccountOptionsProps {
  /** The logged-in user's display name or email address. */
  username: string;
  /** If the component should render the full or compact UI. */
  compact: boolean;
  /** Callback for when the user clicks the logout button. */
  onLogout: () => void;
}

export function AccountOptions({ username, compact, onLogout }: AccountOptionsProps) {
  return (
    <button className={button} onClick={onLogout} aria-label="Logout" type="button">
      <ExitIcon />
      {!compact && <span className={buttonText}>Logout {username}</span>}
    </button>
  );
}
